import window from 'window-or-global';
/**
 * [foxy] we need jQuery here to calculate correct offset => CONFDEV-54151
 * TODO: remove & add test to make sure position is correct
 */
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

export default {
	/**
	 * Returns the offset of the element in relation to the parent frame.
	 * @param element s
	 */
	offset(element) {
		// offset of the element in relation to the frame
		const offset = $(element).offset();
		// offset of the editor
		const frame = $(window.tinymce.activeEditor.iframeElement);
		const frameOffset = frame.offset();
		// Needed because IE doesn't like $body.scrollTop/Left()
		const frameDoc = frame[0].contentWindow.document;
		const $body = $(window.tinymce.activeEditor.getBody());
		const scrollOffset = {
			top: ($.support.boxModel && frameDoc.documentElement.scrollTop) || $body.scrollTop(),
			left: ($.support.boxModel && frameDoc.documentElement.scrollLeft) || $body.scrollLeft(),
		};
		return {
			top: offset.top - scrollOffset.top + frameOffset.top,
			left: offset.left - scrollOffset.left + frameOffset.left,
		};
	},

	/**
	 * Returns the text currently selected in the RTE
	 */
	getSelectedText() {
		const selection = window.tinymce.activeEditor.selection;
		return (
			selection.getRng().text ||
			(selection.getSel() && selection.getSel().toString && selection.getSel().toString()) ||
			''
		);
	},

	/**
	 * put the text in newValue into the editor. This is called when the editor needs new
	 * content -- it is *not* called to set the initial content. That should be done either by providing the
	 * editor with the content as part of the initial HTML, or by calling javascript from editorOnLoad()
	 * @param newValue the html to set the content to.
	 */
	setHtml(newValue) {
		if (newValue) {
			window.tinymce.activeEditor.setContent(newValue);
		}
	},

	/**
	 * @returns the current HTML contents of the editor. This *must* return a JavaScript string,
	 * not a JavaObject wrapping a java.lang.String
	 */
	getHtml() {
		return `${window.tinymce.activeEditor.getContent()}`;
	},

	/**
	 * @returns true if there is no content (other than spaces or &nbsp;). False if there is content.
	 */
	isEmpty() {
		const content = window.tinymce.activeEditor
			.getContent()
			.replace('&nbsp;', '')
			.replace('<br />', '')
			.trim();
		return content === '<p></p>' || content === '';
	},

	/**
	 * @returns true if the contents of the editor has been modified by the user since
	 * the last time editorResetContentChanged()
	 */
	editorHasContentChanged() {
		return window.tinymce.activeEditor.isDirty();
	},

	/**
	 * Resets the contents change indicator
	 */
	editorResetContentChanged() {
		window.tinymce.activeEditor.setDirty(false);
	},

	/**
	 * Finds the index of the supplied childNode in the parentNode
	 * @returns the index of the child node in the parent node. If the child
	 * cannot be found in the parent -1 is returned.
	 */
	getChildIndex(parentNode, childNode) {
		const children = parentNode.childNodes;
		for (let i = 0, len = children.length; i < len; i++) {
			if (children[i] == childNode) {
				return i;
			}
		}
		return -1;
	},
};
